import { Mapper } from "../../../../base/utils/mapper";
import { LocationModel } from "../../../../domain/models/configuration/location.model";
import { LocationEntity } from "../entities/location.entity";



export class LocationImplementationRepositoryMapper extends Mapper<LocationEntity, LocationModel> {
    mapFrom(param: LocationEntity): LocationModel {
        return {
            data:param.data,
            isSuccess:param.isSuccess,
            message:param.message,
            errors:param.errors
        };
    }
    mapTo(param: LocationModel): LocationEntity {
        return {
            data:param.data,
            isSuccess:param.isSuccess,
            message:param.message,
            errors:param.errors
        }
    }
}